import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
} from "@mui/material";
import React, { useState } from "react";

import { connect } from "react-redux";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import {
  publishScholarshipRequests,
  getScholarshipSummary,
} from "../../../../store/scholarship/actions";
import { useEffect } from "react";
import { useRequiredAuth } from "../../common/guard/requiredAuth";

const ScholarshipSummaryDialog = (props) => {
  const {
    loading,
    showDialog,
    setShowDialog,
    publishScholarshipRequests,
    getScholarshipSummary,
    scholarshipSummary,
    executed,
    scholarshipSchedule,
    env,
  } = props;

  // Dev/test backends only: lets Publish run against seed/test data without
  // deciding every pending request first. Never applies when env === "prod".
  const bypassPendingGate = env !== "prod" && !!scholarshipSummary.pending;

  const { hasPermissions } = useRequiredAuth();

  useEffect(() => {
    if (!!showDialog) getScholarshipSummary();
  }, []);

  const [confirmPermutations, setConfirmPermutations] = useState(false);

  return (
    <>
      <Dialog
        onClose={() => {
          setShowDialog(false);
        }}
        fullWidth
        maxWidth="sm"
        open={showDialog}
      >
        <DialogTitle>
          <Typography className="text-center">Scholarship summary</Typography>
          <IconButton
            aria-label="close"
            onClick={() => {
              setShowDialog(false);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className="rounded border" style={{ overflow: "hidden" }}>
            <table className="table table-striped" style={{ fontSize: "12px" }}>
              <tr>
                <th
                  style={{ width: "50%" }}
                  className="text-right text-dark text-uppercase"
                >
                  Total
                </th>
                <th className=" text-dark text-uppercase">
                  {scholarshipSummary.total || 0}
                </th>
              </tr>
              <tr>
                <th className="text-right text-secondary  text-uppercase">
                  Pending
                </th>
                <th className="text-secondary">
                  {scholarshipSummary.pending || 0}
                </th>
              </tr>
              <tr>
                <th className="text-right text-primary  text-uppercase">
                  Sholtlisted
                </th>
                <th className="text-primary">
                  {scholarshipSummary.shortlisted || 0}
                </th>
              </tr>
              <tr>
                <th className="text-right text-danger  text-uppercase">
                  Not Sholtlisted
                </th>
                <th className="text-danger">
                  {scholarshipSummary.notShortlisted || 0}
                </th>
              </tr>
              <tr>
                <th className="text-right text-info  text-uppercase">
                  Under Appeal
                </th>
                <th className="text-info">
                  {scholarshipSummary.underAppeal || 0}
                </th>
              </tr>
              <tr>
                <th className="text-right text-danger  text-uppercase">
                  Rejected
                </th>
                <th className="text-danger">
                  {scholarshipSummary.rejected || 0}
                </th>
              </tr>
              <tr>
                <th
                  className="text-right text-success  text-uppercase"
                  style={{ backgroundColor: "#b1e4ff" }}
                >
                  Selected
                </th>
                <th
                  className="text-success"
                  style={{ backgroundColor: "#b1e4ffc2" }}
                >
                  {scholarshipSummary.selected || 0}
                </th>
              </tr>
              <tr>
                <th
                  className="text-right text-secondary  text-uppercase"
                  style={{ backgroundColor: "#b1e4ff" }}
                >
                  Not Selected
                </th>
                <th
                  className="text-secondary"
                  style={{ backgroundColor: "#b1e4ffc2" }}
                >
                  {scholarshipSummary.notSelected || 0}
                </th>
              </tr>
            </table>
          </div>
        </DialogContent>
        {hasPermissions(["SCHOLARSHIPS_PUBLISH"]) && (
          <DialogActions className="d-flex flex-column align-items-center pb-4">
            {bypassPendingGate && (
              <Alert severity="warning" sx={{ mb: 2, width: "100%" }}>
                {env} environment: publishing with {scholarshipSummary.pending}{" "}
                pending request(s) — this is blocked in production.
              </Alert>
            )}
            <Button
              color="success"
              variant="contained"
              onClick={() => setConfirmPermutations(true)}
              type="button"
              disabled={
                loading ||
                !!scholarshipSchedule?.published ||
                !scholarshipSummary.total ||
                (!!scholarshipSummary.pending && env === "prod") ||
                !executed
              }
              className={bypassPendingGate ? "px-5" : "mt-n3 px-5"}
            >
              <span className="material-icons">publish</span>
              Publish
            </Button>
          </DialogActions>
        )}
      </Dialog>

      {confirmPermutations && (
        <ConfirmationDialog
          confirmationDialog={confirmPermutations}
          message={
            <>
              <span>Are you sure you want to publish?</span>
            </>
          }
          setConfirmationDialog={setConfirmPermutations}
          onYes={() => {
            publishScholarshipRequests(() => {
              setConfirmPermutations(false);
              setShowDialog(false);
            });
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = ({
  loading,
  scholarshipSummary,
  scholarshipSchedule,
  env,
}) => {
  return { loading, scholarshipSummary, scholarshipSchedule, env };
};
export default connect(mapStateToProps, {
  publishScholarshipRequests,
  getScholarshipSummary,
})(ScholarshipSummaryDialog);
